/**
 * Fixture rendered by `useBlueprints()` for anonymous readers, in Storybook,
 * and on live-failure fallback (PRD-9a / Guided Demos pivot).
 *
 * The shape mirrors the live `Blueprint[]` payload exactly so the launch
 * form can render either fixture or live data without branching.
 */
import type { Blueprint } from '@/lib/types';

const NOW = 1735689600000; // 2025-01-01T00:00:00Z — stable epoch for snapshot tests.

export const blueprintsFixture: Blueprint[] = [
  {
    id: 'bpt_demo_base',
    name: 'base',
    status: 'build_complete',
    createTimeMs: NOW,
    buildFinishTimeMs: NOW,
    resourceSize: 'MEDIUM',
  },
  {
    id: 'bpt_demo_deepwiki',
    name: 'deepwiki-demo',
    status: 'build_complete',
    createTimeMs: NOW,
    buildFinishTimeMs: NOW,
    resourceSize: 'MEDIUM',
    metadata: {
      repo: 'runloopai/api-client-ts',
    },
  },
];
